import { WayflyerSchemas } from "api-types";
import type { IntlShape } from "react-intl";
import * as Yup from "yup";
const emailValidationMessage = (intl: IntlShape) =>
  intl.formatMessage({
    id: "invite-modal: auth email validate message",
    defaultMessage: "Please enter only valid work email addresses.",
  });

const rolesValidationMessage = (intl: IntlShape) =>
  intl.formatMessage({
    id: "invite-modal: auth roles validate message",
    defaultMessage: "Please select a role for the invited member.",
  });

export const emailAuthValidationSchema = (intl: IntlShape) => ({
  emails: Yup.string()
    .required(emailValidationMessage(intl))
    .test("isValidEmails", emailValidationMessage(intl), (value: string | undefined) => {
      if (typeof value !== "string") {
        return false;
      }
      const emails = value
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email !== "");
      return emails.every((email) => Yup.string().email().isValidSync(email));
    }),
});

export const rolesValidationSchema = (intl: IntlShape, isBankingCustomer: boolean) => ({
  role: Yup.mixed<WayflyerSchemas.CompanyRole>()
    .oneOf(["admin", "financial_assistant", "user"])
    .nullable()
    .when([], {
      is: () => isBankingCustomer,
      then: (schema) => schema.required(rolesValidationMessage(intl)),
      otherwise: (schema) => schema.notRequired(),
    }),
});
